import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_BEGIN,
  TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_SUCCESS,
  TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_FAILURE,
  TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_DISMISS_ERROR,
} from './constants';

export function fetchAllTypesenseSearchTemplate(args = {}) {
  return (dispatch) => {
    dispatch({
      type: TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_BEGIN,
    });

    const { projectId, version } = args;
    const config = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/templates?templateType=TYPESENSE_SEARCH`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAllTypesenseSearchTemplateError() {
  return {
    type: TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_BEGIN:
      return {
        ...state,
        fetchAllTypesenseSearchTemplatePending: true,
        fetchAllTypesenseSearchTemplateError: null,
      };

    case TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchAllTypesenseSearchTemplatePending: false,
        fetchAllTypesenseSearchTemplateError: null,
        typesenseSearchTemplates: action.data,
      };

    case TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchAllTypesenseSearchTemplatePending: false,
        fetchAllTypesenseSearchTemplateError: action.data.error,
      };

    case TEMPLATE_FETCH_ALL_TYPESENSE_SEARCH_TEMPLATE_DISMISS_ERROR:
      return {
        ...state,
        fetchAllTypesenseSearchTemplateError: null,
      };

    default:
      return state;
  }
}
